import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=81f88ee0&lang=pug&"
import script from "./Pay.vue?vue&type=script&lang=ts&"
export * from "./Pay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports